import type {
	UserForm,
	UserMutations,
	UserProfile,
	UserRoles,
	UserTranslations,
	ValidationMessages,
} from "Infrastructure/Translation/Types/user";

const formTranslations: UserForm = {
	email: "Email",
	name: "Name",
	surname: "Surname",
	permissions: "Permissions",
	save: "Save",
	password: "Password",
	id: "ID",
	preselectedMarketId: "Preselected market",
	nickname: "Nickname",
	publicPhoneNumber: "Public phone number",
};

const userMutationTranslations: UserMutations = {
	userUpdateSuccess: "User updated successfully",
	userUpdateError: "Failed to update user",
	userCreateRoleSuccess: "User role was successfully created.",
	userCreateRoleError: "An error occurred while creating the user role.",
	userUpdateRoleSuccess: "User role was successfully updated.",
	userUpdateRoleError: "An error occurred while updating the user role.",
	userUploadAvatarSuccess: "Avatar uploaded successfully",
	userUploadAvatarError: "Failed to upload avatar",
};

const userProfileTranslations: UserProfile = {
	myProfile: "My profile",
	accountSettings: "Account settings",
};

export const userRolesTranslations: UserRoles = {
	addRole: "Add Role",
	name: "Name",
	comment: "Comment",
	customer: "Customer",
	invoice: "Invoice",
	save: "Save",
	invoiceitem: "Invoice Item",
	market: "Market",
	marketregion: "Market Region",
	ordercall: "Order Call",
	orderclaim: "Order Claim",
	ordernotification: "Order Notification",
	order: "Order",
	orderinvoice: "Order Invoice",
	orderfield: "Order Field",
	ordersetup: "Order Setup",
	orderfieldvalue: "Order Field Value",
	orderimport: "Order Import",
	orderpartnerreview: "Order Partner Review",
	vertical: "Vertical",
	companybankdetail: "Company Bank Detail",
	partneraddress: "Partner Address",
	partnerbalance: "Partner Balance",
	partnerbillingprofile: "Partner Billing Profile",
	partnerbankaccount: "Partner Bank Account",
	partnerstatistic: "Partner Statistics",
	partner: "Partner",
	servestatic: "Serve Static",
	storage: "Storage",
	translation: "Translation",
	userroles: "User Roles",
	audit: "Audit",
	marketregionsetting: "Market Region Setting",
	orderaudit: "Order Audit",
	ordertimeline: "Order Timeline",
	partneraudit: "Partner Audit",
	partnerbalancefeeinvoiceitem: "Partner Balance Fee Invoice Item",
	partnerbalancefeeinvoice: "Partner Balance Fee Invoice",
	partnerbalancetransaction: "Partner Balance Transaction",
	repositories: "Repositories",
	user: "User",
	company: "Company",
	title: "User Roles Management",
	description:
		"Manage user roles, add new roles, and edit existing roles in this section.",
	selectAll: "Select all",
	card: {
		heading: "Manage Roles",
		subheading: "Choose a role from the list to edit or add a new user role",
	},
	emailreplacer: "Email Replacer",
	orderpayment: "Order Payment",
	orderpaymentdetail: "Order Payment Detail",
	verticalemailtemplates: "Vertical Email Templates",
	verticalgeneralsetup: "Vertical General Setup",
	orderfee: "Order Fee",
	ordercharge: "Order Charge",
	orderprice: "Order Price",
	orderexamination: "Order Examination",
	bank: "Payments / Payouts",
};

export const validationMessagesTranslations: ValidationMessages = {
	name: "Name is required.",
	surname: "Surname is required.",
	email: "Email is required.",
	emailFormat: "Invalid email format.",
};

const userTranslations: UserTranslations = {
	edit: "Edit User",
	form: formTranslations,
	mutations: userMutationTranslations,
	profile: userProfileTranslations,
	roles: userRolesTranslations,
	validationMessages: validationMessagesTranslations,
};

export default userTranslations;
